export default __webpack_public_path__ + "static/media/IconTravelSpot.e6e9bc57.svg";